'use client';

import Pricing from './pricing';
import ProductPoints from './product-points';
import ProductRatings from './product-ratings';
import ExtraAttributes from './extra-attributes';
import { useTranslations } from 'next-intl';
// import { checkStockAvailability } from '@/utils/global';
// import useGlobalStore from '@/store/global.store';
import GiftItems from './free-gift-items';
import CartRules from '../cart-rules';
import WidgetsWrapper from '@/components/installments-widgets';
import ComboProductsList from '../combo/Combo';
// import StarIcon from '@/components/ui/icons/star-icon';
// import PriceBar from './price-bar';

const ProductDetail = ({
  name,
  price,
  sku,
  required_prescripation,
  free_gifts,
  entity_id,
  categories,
  brand,
  rabeh_earn_points,
  label,
  productCategory,
  // stock_innova,
  bundleProductOptions,
  session,
  cart_rules,
  eligible_for_tabby,
  eligible_for_tamara,
  showDiscountLabel,
  stock,
}) => {
  const t = useTranslations('product');
  // const { defaultSourceIds } = useGlobalStore();
  // const is_stock = checkStockAvailability(stock_innova || {}, defaultSourceIds);
  const is_stock = stock?.is_in_stock && stock?.qty > 0;

  return (
    <div className='flex flex-col gap-4 md:mb-[11px] lg:px-8'>
      <ExtraAttributes
        brand={brand}
        t={t}
        label={label}
        productCategory={productCategory}
      />

      <h1 className='text-xl leading-relaxed font-bold max-sm:mt-3 sm:leading-7 lg:leading-9.5'>
        {name}
      </h1>
      <div className='mb-5 flex items-center justify-between gap-3'>
        {/* <div className='flex'>
          {[1, 2, 3, 4].map((star) => (
            <StarIcon
              key={star}
              size={18}
              className='fill-yellow-400 text-yellow-400'
            />
          ))}
          <StarIcon
            size={18}
            className='text-yellow-400'
            style={{
              fill: 'none',
            }}
          />
        </div> */}

        {/* <span className='text-sm font-medium'>4.8</span> */}

        <div className='rounded-full bg-gray-100 px-3 py-1'>
          <span className='text-sm font-medium text-gray-600'>
            {t('SKU')} : {sku}
          </span>
        </div>

        <div className='rounded-full bg-gray-100 px-3 py-1'>
          <span className='text-sm font-medium text-gray-600'>
            {' '}
            {t(is_stock ? 'inStock' : 'out_of_stock')}
          </span>
        </div>
      </div>

      <ProductRatings entity_id={entity_id} categories={categories} />
      <div className='mt-6 flex items-baseline justify-between border-t border-gray-100 py-2 max-sm:mt-2'>
        <Pricing price={price} showOfferLabel={is_stock} />
        <div className='flex items-center justify-end gap-2'>
          <CartRules
            rules={cart_rules}
            showBulkDiscount={showDiscountLabel}
            showOfferLabel={is_stock}
            isPdp
          />
          {required_prescripation && (
            <div
              className={`flex w-fit items-center gap-0.5 rounded-xl bg-[#FFFAD3] px-2.25 py-0.75 text-center text-xs font-bold text-[#89701A]`}
            >
              {t('prescriptionRequired')}
            </div>
          )}
        </div>
      </div>
      {/* <PriceBar price={price} rabeh_earn_points={rabeh_earn_points} /> */}

      <ComboProductsList {...{ bundleProductOptions, t }} />
      <ProductPoints
        price={price}
        rabeh_earn_points={rabeh_earn_points}
        session={session}
      />
      {free_gifts?.length > 0 && <GiftItems data={free_gifts} />}
      <div className='hidden sm:flex'>
        <WidgetsWrapper
          price={price}
          fromPDP
          eligible_tabby={eligible_for_tabby}
          eligible_tamara={eligible_for_tamara}
        />
      </div>
    </div>
  );
};

export default ProductDetail;
